(function() {
  var root = document.documentElement;
  var nav = window.navigator || {};
  var connection = nav.connection || nav.mozConnection || nav.webkitConnection;
  var cores = nav.hardwareConcurrency || 4;
  var memory = nav.deviceMemory || 4;
  var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = Boolean(connection && connection.saveData);
  var slowNetwork = Boolean(connection && /(^2g$|slow-2g|3g)/i.test(connection.effectiveType || ''));
  var narrow = Math.min(window.innerWidth || 9999, window.screen && window.screen.width || 9999) < 760;
  var perf = 'high';

  if (reducedMotion || saveData || slowNetwork || memory <= 2 || cores <= 2) {
    perf = 'low';
  } else if (coarse || narrow || memory <= 4 || cores <= 4) {
    perf = 'medium';
  }

  root.classList.add('ace-perf-' + perf);
  if (coarse) root.classList.add('ace-touch');

  function pauseDecorativeAnimations() {
    if (!('IntersectionObserver' in window)) return;

    var decorative = document.querySelectorAll(
      '.ace-top-menu__stars, .ace-top-menu__stars--near, .ace-top-menu__stars--far, .ace-top-menu__aurora, .ace-top-menu__veil, ' +
      '.ace-immersive__moment-stars, .ace-proof__stars, .ace-services__haze, .ace-pull-image__stars'
    );

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        entry.target.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
      });
    }, {
      rootMargin: '160px 0px'
    });

    decorative.forEach(function(node) {
      observer.observe(node);
    });
  }

  function pauseHiddenVideos() {
    if (!('IntersectionObserver' in window)) return;

    var videos = document.querySelectorAll('video:not([data-ace-moment-video]):not([data-ace-autoplay])');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var video = entry.target;
        if (!entry.isIntersecting && !video.paused) {
          video.pause();
        }
      });
    }, {
      rootMargin: '220px 0px',
      threshold: 0
    });

    videos.forEach(function(video) {
      observer.observe(video);
    });
  }

  function syncHiddenTabWork() {
    var animated = document.querySelectorAll(
      '.ace-top-menu__stars, .ace-top-menu__stars--near, .ace-top-menu__stars--far, .ace-top-menu__aurora, .ace-top-menu__veil, ' +
      '.ace-immersive__moment-stars, .ace-proof__stars, .ace-services__haze, .ace-pull-image__stars'
    );

    animated.forEach(function(node) {
      node.style.animationPlayState = document.hidden ? 'paused' : '';
    });

    if (document.hidden) {
      document.querySelectorAll('video').forEach(function(video) {
        if (!video.paused && !video.hasAttribute('data-ace-keep-playing-hidden')) {
          video.dataset.acePausedHidden = 'true';
          video.pause();
        }
      });
      return;
    }

    document.querySelectorAll('video[data-ace-paused-hidden="true"]').forEach(function(video) {
      video.dataset.acePausedHidden = 'false';
      if (video.hasAttribute('autoplay') || video.dataset.aceAutoplay === 'true') {
        video.play().catch(function() {});
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      pauseDecorativeAnimations();
      pauseHiddenVideos();
      syncHiddenTabWork();
    });
  } else {
    pauseDecorativeAnimations();
    pauseHiddenVideos();
    syncHiddenTabWork();
  }

  document.addEventListener('visibilitychange', syncHiddenTabWork);
})();
